<div class="min-h-screen flex bg-shikenso-base-white">
  <div class="flex-[0.5] flex flex-col items-center mx-auto my-auto">
    <div class="flex w-full items-center justify-center mb-12">
      <img src="images/logo/logo.png" alt="Logo" width="36" />
    </div>

    <div class="bg-shikenso-gray-base px-14 py-10 rounded-2xl max-w-[440px]">
      <div class="flex flex-col items-center justify-center gap-2 mb-6 px-6">
        <h1 class="text-[28px] font-bold text-black">{{ 'pages.forgotPassword.title' | translate }}</h1>
        <p class="text-shikenso-gray-700 text-sm text-center">{{ 'pages.forgotPassword.description' | translate }}</p>
      </div>

      <form class="flex flex-col gap-2 custom-form" [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()">
        <mat-form-field class="w-full">
          <input matInput type="email" formControlName="email" [placeholder]="'pages.login.email' | translate" />
          @if (forgotPasswordForm.get('email')?.hasError('required')) {
            <mat-error>
              {{ 'pages.login.emailRequired' | translate }}
            </mat-error>
          }
          @if (forgotPasswordForm.get('email')?.hasError('email')) {
            <mat-error>
              {{ 'pages.login.emailInvalid' | translate }}
            </mat-error>
          }
        </mat-form-field>

        <button mat-flat-button type="submit" class="mat-primary-button-color font-medium" [disabled]="sendingEmail">
          @if (sendingEmail) {
            <app-dots-spinner />
          } @else {
            {{ 'pages.forgotPassword.sendResetLink' | translate }}
          }
        </button>
      </form>

      <button
        mat-flat-button
        type="button"
        class="w-full mt-2"
        color="secondary-transparent"
        [disabled]="sendingEmail"
        (click)="backToSignIn()"
      >
        {{ 'pages.forgotPassword.backToSignIn' | translate }}
      </button>
    </div>
  </div>

  <div class="flex-[0.5] login-image"></div>
</div>
